import http from '../../../../api/http';
import type { CentroCostoContable, AreaContable } from '../types/centroCosto';

const ENDPOINTS = {
  CENTROS_COSTO: '/contabilidad/centros-costo',
  AREAS: '/contabilidad/areas',
};

export class CentroCostoService {
  public static async getAll(): Promise<CentroCostoContable[]> {
    const response = await http.get(ENDPOINTS.CENTROS_COSTO);
    return response.data;
  }

  public static async getById(id: number): Promise<CentroCostoContable> {
    const response = await http.get(`${ENDPOINTS.CENTROS_COSTO}/${id}`);
    return response.data;
  }

  public static async save(centroCosto: Partial<CentroCostoContable>): Promise<CentroCostoContable> {
    const response = await http.post(ENDPOINTS.CENTROS_COSTO, centroCosto);
    return response.data;
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINTS.CENTROS_COSTO}/${id}`);
  }

  // Areas
  public static async getAllAreas(): Promise<AreaContable[]> {
    const response = await http.get(ENDPOINTS.AREAS);
    return response.data;
  }

  public static async saveArea(area: Partial<AreaContable>): Promise<AreaContable> {
    const response = await http.post(ENDPOINTS.AREAS, area);
    return response.data;
  }

  public static async deleteArea(id: number): Promise<void> {
    await http.delete(`${ENDPOINTS.AREAS}/${id}`);
  }
}
